<template>
   <div>
      <!-- 落地页 -->
      <div class="landingPage" v-if="landingPageFlag">
                  <div class="landingPage-top">
                        <div class="landing">
                              <p class="bigTitle">全网商机实时推送<br/>商机开发快人一步</p>
                              <p class="des">Real time push of business opportunities throughout the network,<br/>One step faster in business opportunity development</p>
                              <div class="btn" @click="goSubscribe('add')">
                                    <span>前往订阅</span>
                              </div>
                        </div>
                  </div>
                  <div class="landingPage-bottom">
                        <div class="lpGuide lpGuide-01 clearfix">
                              <div class="img lf">
                                    <img src="@/assets/subscribe/landing-02.png">
                              </div>
                              <div class="txt rt">
                                    <p class="bigTitle">多种商机可订阅，精准覆盖拓客场景</p>
                                    <div class="des">
                                          <p>新成立的企业</p>
                                          <p>新增ICP的企业</p>
                                          <p>新建网站的企业</p>
                                          <p>新增招投标的企业</p>
                                    </div>
                              </div>
                        </div>
                        <div class="lpGuide lpGuide-02 clearfix">
                              <div class="txt lf">
                                    <p class="bigTitle">针对不同商机配置偏好，精细化定义商机客群</p>
                              </div>
                              <div class="img rt">
                                    <img src="@/assets/subscribe/landing-03.png">
                              </div>
                        </div>
                        <div class="lpGuide lpGuide-03 clearfix">
                              <div class="img lf">
                                    <img src="@/assets/subscribe/landing-04.png">
                              </div>
                              <div class="txt rt">
                                    <p class="bigTitle">实时分析满足条件的商机，开发业务快人一步</p>
                              </div>
                        </div>
                  </div>
      </div>
      <subscribe-drawer ref="subscribeDrawer"></subscribe-drawer>
    </div>
</template>
<script>
import subscribeDrawer from '@/components/subscribeDrawer'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
export default {
      components:{
           subscribeDrawer
      },
      data(){
            return{
                  // landingPageFlag:false
            }
      },
      computed:{
            ...mapState({
                  landingPageFlag:state => state.user.landingPageFlag
            }),
      },
      methods:{
            landingPageShow(){
            //    this.landingPageFlag = true
               this.$store.commit('SET_LANDING_PAGE',true)
            },
            goSubscribe(type){
                  this.$store.commit('SET_LANDING_PAGE',false)
                  this.$router.push('/zxk/junbros/subscribeManagement?ld=true&type='+type)
            
             },
      }
}
</script>
<style lang="scss" scoped>
    .landingPage{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 2;
      background: #FFFFFF;
      box-shadow: 0px 1px 5px 0px rgba(38,38,38,0.1);
      .landingPage-top{
        background: url(~@/assets/subscribe/landing-01.png) no-repeat center;
        background-size: cover;
        height:750px;
        .landing{
             padding-top: 170px;
             padding-left: 130px;
             padding-bottom: 175px;
             box-sizing: border-box;
             .bigTitle{
                   font-weight: bold;
                  color: #343951;
                  line-height: 54px;
                  font-size: 46px;
                  margin-bottom: 16px;
             }
             .des{
               font-size: 13px;
              font-family: ArialMT;
              color: #666666;
              margin-bottom: 34px;
             }
             .btn{
                   width: 200px;
                    height: 50px;
                    line-height: 50px;
                    background: linear-gradient(90deg, #FFC941 0%, #FF9800 100%);
                    box-shadow: 0px 4px 11px 0px rgba(255,176,4,0.3);
                    border-radius: 30px;
                    text-align: center;
                    cursor: pointer;
                    span{
                      font-weight: bold;
                      color: #FFFFFF;
                      font-size: 20px;
                    }
             }
        }
      }
      .landingPage-bottom{
        padding: 0 130px;
        box-sizing: border-box;
           .lpGuide{
             margin-bottom: 70px;
                .img{
                    // width: 519px;
                    // width: 37.446%;
                    width: 50%;
                    height: 445px;
                    position: relative;
                    img{
                      max-width: 100%;
                      max-height: 100%;
                      display: block;
                      position: absolute;
                      top: 0;
                      bottom: 0;
                      left: 0;
                      right: 0;
                      margin: auto;
                    }
                }
                .txt{
                   width: 38%;
                  //  float: left;
                  //  padding-top: 111px;
                      padding: 148px 0;
                   .bigTitle{
                     font-weight: 600;
                    color: #343951;
                    line-height: 38px;
                    font-size: 30px;
                    margin-bottom: 24px;
                   }
                   .des{
                      p{
                           font-weight: 400;
                            color: #666666;
                            line-height: 22px;
                            font-size: 16px;
                            position: relative;
                            padding-left: 12px;
                            box-sizing: border-box;
                            width: 50%;
                            float: left;
                            margin-bottom: 20px;
                            &::before{
                              position: absolute;
                              content: '';
                              display: block;
                                width: 4px;
                                height: 17px;
                                background: #5088FF;
                                border-radius: 1px;
                                top: 0;
                                bottom: 0;
                                left: 0;
                                margin: auto;
                            }
                      }
                   }
                }
           }
      }
    }
.clearfix::before,.clearfix::after{
  display: block;
  content: '';
  clear: both;
}
.lf{
  float: left;
}
.rt{
  float: right;
}
@media screen and(max-width:1740px){
  .landingPage .landingPage-top{
      height: auto;
  }
  .landingPage .landingPage-top .landing{
    padding-left: 97px;
    padding-top: 111px;
  }
  .landingPage .landingPage-bottom{
    padding: 0 65px;
  }
  .landingPage .landingPage-bottom .lpGuide .img{
    width: 53.0%;
    height: 338px;
  }
  .landingPage .landingPage-bottom .lpGuide .txt{
//     padding-top: 71px;
   padding: 75px 0;
  }
   .landingPage .landingPage-bottom .lpGuide.lpGuide-02 .txt,.landingPage .landingPage-bottom .lpGuide.lpGuide-03 .txt{
   padding: 97px 0;
  }
}
</style>